import clsx from "clsx";
import React, { DetailedHTMLProps, FC, HTMLAttributes } from "react";

import { useLabels } from "../../../contexts/labels";
import { getLocalizedPath } from "../../../utils/pages";
import { PersonalAreaTabButton } from "../personal-area-tab-button";

export interface PersonalAreaTabListProps
  extends Pick<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>, "className"> {
  node_locale: string;
  currentPage: "profile" | "calendar";
  isCorporateAccount?: boolean;
}

export const PersonalAreaTabList: FC<PersonalAreaTabListProps> = ({
  node_locale,
  className,
  currentPage,
  isCorporateAccount = false,
}) => {
  const { labels } = useLabels();
  const profileUrl = getLocalizedPath("/personal-area/profile", node_locale);
  const calendarUrl = getLocalizedPath("/personal-area/calendar", node_locale);

  return (
    <>
      <div className={clsx("flex justify-center gap-6 w-full invisible lg:visible", className)}>
        {!isCorporateAccount && (
          <PersonalAreaTabButton
            linkUrl={profileUrl}
            label={labels["personal-area-profile-tab-cta"] ?? ""}
            icon="profile"
            active={currentPage === "profile"}
            className="flex-[0_0_50%]"
          />
        )}
        <PersonalAreaTabButton
          linkUrl={calendarUrl}
          label={labels["personal-area-calendar-tab-cta"] ?? ""}
          icon="calendar-check"
          className="flex-[0_0_50%]"
          active={currentPage === "calendar"}
        />
      </div>
      <div className={clsx("flex gap-6 w-full lg:invisible visible justify-center", className)}>
        {!isCorporateAccount && (
          <a
            href={profileUrl}
            className={clsx(
              "text-lg leading-tight font-normal p-4",
              currentPage === "profile"
                ? "bg-light text-primary rounded-4xl border border-primary"
                : "text-dark"
            )}
          >
            {labels["personal-area-profile-tab-cta"] ?? ""}
          </a>
        )}
        <a
          href={calendarUrl}
          className={clsx(
            "text-lg leading-tight font-normal p-4",
            currentPage === "calendar"
              ? "bg-light text-primary rounded-4xl border border-primary"
              : "text-dark"
          )}
        >
          {labels["personal-area-calendar-tab-cta"] ?? ""}
        </a>
      </div>
    </>
  );
};
